import './App.css';
import './index.css';
import React from 'react';
import Bar from './component/navbar';
import Footer from './component/footer';

function App() {
  return (
    <>
   < Bar />
   <Footer />
    </>
  );
}

export default App;
